module.exports = __webpack_public_path__ + "static/media/tt.9574aff3.svg";